import React from "react";
import { styled } from "styled-components";
import { Amount } from "./AccountBalanceInput";

export interface TransactionFeeContainerProps {
  transactionFee: number;
  currency: string;
  style?: React.CSSProperties;
}
const TransactionFeeContainer: React.FC<TransactionFeeContainerProps> = ({
  transactionFee,
  currency,
  style = {},
}) => {
  const formattedAmount = transactionFee.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return (
    <Container style={style}>
      <span> Transaction Fee:</span>
      <Amount>
        {currency}
        {formattedAmount}
      </Amount>
    </Container>
  );
};

export default TransactionFeeContainer;

export const Container = styled.div`
  width: 40%;
  width: 40%;
  background: #ceccde;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0.8rem;
  border-radius: 5px;
  box-sizing: border-box;

  box-sizing: border-box;

  span {
    color: #0e0e0e;
    flex-shrink: 0;
    @media screen and (max-width: 768px) {
      font-size: 13px;
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) {
      font-size: 14px;
    }
  }
  @media screen and (max-width: 767px) {
    width: 50%;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    width: 50%;
  }
`;
